import { Component, OnInit, AfterContentInit, AfterViewInit, ViewChild, } from '@angular/core';
import { Router, ActivatedRoute, } from '@angular/router';
import { LoginViewModel } from '../models/login-view-model';
import { userProfile } from '../models/userProfile';
import { Location } from '@angular/common';
import * as Cookie from 'js-cookie';
import { DataService } from '../services/data.service';
import { AuthService } from '../services/auth/auth.service';
import { ContractService } from '../services/contract.service';
import { AdminService } from '../services/Admin.service';
import { LoginResult } from '../models/LoginResult';
import { AccountService } from '../services/account.service';
import { JssiFooterComponent } from './../shared-components/jssi-footer/jssi-footer.component';
import { UserDisplayInfo } from '../models/UserDisplayInfo';
import { ModalComponent } from '../shared-components/modal/modal.component';
import { TransientTypes } from '../models/TransientTypes';
@Component({
  selector: 'app-pages',
  templateUrl: './pages.component.html',
  styleUrls: ['./pages.component.scss']
})
export class PagesComponent implements OnInit, AfterContentInit, AfterViewInit {
  transientTypes = TransientTypes;
  currentTransientType: TransientTypes = TransientTypes.cdd;
  currentTransientUrl: string;
  opened = true;
  checkMobileSupportMsg: string;
  isMobile: boolean;
  currentDate: Date;
  @ViewChild('popup') popup: ModalComponent;
  public imageURL = 'assets/icons/icon-jssi-logo.png';
  private loginVM: LoginViewModel;
  private CDDURL: string;
  private PartsURL: string;
  CookieAgreementAccepted: string;
  CookieAgreementObj: any;
  loading: Boolean = false;
  externalUrl: string;
  isAnnualMeeting = false;
  isvendorurl: Boolean = false;
  navselected: string = '';
  clientnavselected: string = 'nav-selected';
  homenavselected: string = '';
  advisoryselected:string='';
  loginpage = false;
  agreedToGDPR: any = {
    confirmed: 'no'
    , core: { agreed: 'yes', cookielist: [] }
    , analytics: { agreed: 'yes', cookielist: [] }
    , marketing: { agreed: 'yes', cookielist: [] }
    , advertising: { agreed: 'yes', cookielist: [] }
    , privacyPolicy: ''
    , gdprUserMessage: ''


  };
  constructor(public dataService: DataService, private authService: AuthService,
    public _router: Router,
    private activatedRoute: ActivatedRoute,
    private contractSvc: ContractService,
    _dataService: DataService,
     location: Location) {
      this.navselected = '';
      this.clientnavselected = '';
      this.homenavselected = '';
      this.advisoryselected = '';
      this.loginpage = false;
    console.log("cookie check");
    this.checkMobileSupportMsg = sessionStorage.getItem('mobileSupportMsgView');
    if (window.innerWidth <= 800 && window.innerHeight <= 640) {
      this.isMobile = true;
      this.opened = false;
      sessionStorage.setItem('mobileSupportMsgView', 'seen');
      this.checkMobileSupportMsg = sessionStorage.getItem('mobileSupportMsgView');
    } else {
      this.isMobile = false;
    }

    if (location.path().indexOf('pre-chat') > -1) {
      this.opened = false;
      this.isMobile = false;
      this.loginpage = true;

    }
    if (location.path().indexOf('vendor') > -1) {
      this.isvendorurl = true;
      this.navselected = 'nav-selected';
      this.clientnavselected = '';
      this.homenavselected = '';
      this.advisoryselected = '';
    } else if (location.path().indexOf('myjssi-bundle') > -1) {
      this.navselected = '';
      this.clientnavselected = '';
      this.homenavselected = 'nav-selected';
      this.advisoryselected = '';
    } else if (location.path().indexOf('advisory') > -1) {
      this.navselected = '';
      this.clientnavselected = '';
      this.homenavselected = '';
      this.advisoryselected = 'nav-selected';
    } else   {
      this.isvendorurl = false;
      this.navselected = '';
      this.homenavselected = '';
      this.advisoryselected = '';
      this.clientnavselected = 'nav-selected';
      if (_dataService.userDisplayInfo) {
      _dataService.userDisplayInfo.UserTypeID = 1;

      }
    }

    // console.log('dataService.userDisplayInfo',  JSON.stringify(dataService.userDisplayInfo));
    //console.log('actualusertypeFlag', dataService.userDisplayInfo.ActualUserTypeID === 3 && dataService.userDisplayInfo.UserTypeID === 1);

  }

  ngOnInit() {
    this.currentDate = new Date();



  }
  async ngAfterViewInit() {
    this.CDDURL = await this.contractSvc.getConfigLogin('CDDUrl');
    this.PartsURL = await this.contractSvc.getConfigLogin('JSSIPartsUrl');
    console.log('CDD url', this.CDDURL);

  }

  gdprAgreeFn() {
    this.agreedToGDPR.confirmed = 'yes';
    Cookie.set('gdrpAgreed', JSON.stringify(this.agreedToGDPR));
    console.log(Cookie.getJSON('gdrpAgreed'));
    this.CookieAgreementObj = JSON.parse(Cookie.get('gdrpAgreed'));
    this.CookieAgreementAccepted = this.CookieAgreementObj.confirmed;

  }

  getGDPRAgreeFn() {
    if (Cookie.get('gdrpAgreed')) {
      this.CookieAgreementObj = JSON.parse(Cookie.get('gdrpAgreed'));
      this.CookieAgreementAccepted = this.CookieAgreementObj.confirmed;
    } else {
      Cookie.set('gdrpAgreed', JSON.stringify(this.agreedToGDPR));
      this.CookieAgreementObj = JSON.parse(Cookie.get('gdrpAgreed'));
      this.CookieAgreementAccepted = this.CookieAgreementObj.confirmed;


    }

  }

  mouseover() {
    setTimeout(() => this.imageURL = 'assets/icons/icon-jssi-horizontal-logo.png', 100);
  }
  mouseout() {
    setTimeout(() => this.imageURL = 'assets/icons/icon-jssi-logo.png', 100);
  }


  ngAfterContentInit() {
    console.log('cookie check', document.cookie);

    this.getGDPRAgreeFn();
  }
  logout() {
    this.authService.logOut();
    location.href = '/';
  }
  onSwitchButtonClick(destinationAppId: string, transientType: TransientTypes) {
    console.log('inside swtich button');
    this.loading = false;
    if (this.dataService.userDisplayInfo.UserTypeID === 5) {
      this.loading = true;
      this.authService.getImpersonateMYJSSIuser(this.dataService.userDisplayInfo.id,
        this.dataService.userDisplayInfo.adminbearerToken, this.dataService.userDisplayInfo.Email)
        .subscribe(
          url => {
            console.log('URL', url );

          //  this.authService.logOut();
          window.location.href = url + '&impersonate=1';
          }
        );
    } else {
    this.currentTransientType = transientType;
    this.loading = false;
    if (!this.loading) {
      this.loading = true;
      console.log('this.dataService.userDisplayInfo.id', JSON.stringify(this.dataService.userDisplayInfo));

      this.authService.getTransientUrl(this.dataService.userDisplayInfo.id, destinationAppId,
        this.dataService.userDisplayInfo.bearerToken)
        .subscribe(
          url => {
            console.log('URL', url);
            this.externalUrl = url;
            this.currentTransientUrl = url;
            const urlSplits = url.split('?');
            if (urlSplits.length > 1) {
              const paramString = urlSplits[1];
              const queryString = new URLSearchParams(paramString);
              const authToken = queryString.get('token');
              if (authToken == null) {
                location.href = url;
              }
              const firstTimeLoggingIn = authToken.split('^')[1];
              if (firstTimeLoggingIn === '1') {
                this.popup.show();

              } else {

                this.authService.logOut();
                location.href = url;

                // console.log(url);

              }
            } else {

              this.authService.logOut();
              location.href = url;

              // console.log(url);

            }
          }

        );
    }
  }
    return false;
  }

  ExternalContinue() {
    location.href = this.externalUrl;
  }

  navigateToOtherSite(url: string) {
    this.authService.logOut();
    location.href = this.externalUrl;
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/pages.component.ts